<section class="transition-transform transform hover:scale-105">
  <div
    class="relative bg-black text-white rounded-lg overflow-hidden shadow-lg h-72 cursor-pointer"
  >
    <!-- Price Badge -->
    <span
      class="absolute right-2 top-2 z-10 text-2xl bg-black text-xs font-bold p-2 rounded-md"
    >
      {{ event.minPrice | priceFormatter : event.maxPrice }}
    </span>

    <!-- TODO: Uncomment when wishlist functionality is finalized -->
    <!-- Wishlist Icon -->
    <!-- <button
      (click)="toggleWishlist($event)"
      [disabled]="wishlistLoading()"
      class="absolute left-2 top-2 z-10 bg-black/70 hover:bg-black text-white p-2 rounded-full transition-colors"
      [class.opacity-50]="wishlistLoading()"
      type="button"
    >
      <span
        nz-icon
        nzType="heart"
        [class.text-red-500]="isInWishlist()"
        [class.text-white]="!isInWishlist()"
        [class.opacity-50]="!isInWishlist()"
        [class.fill-current]="isInWishlist()"
        class="text-lg"
      ></span>
    </button> -->
    <div class="relative h-full">
      <!-- Event Image with Zoom on Hover -->
      <img
        nzDisablePreview
        nz-image
        class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        [nzSrc]="eventImageUrl"
        nzFallback="assets/placeholder.jpg"
        [alt]="event.name"
      />

      <!-- Gradient Overlay -->
      <div
        class="absolute inset-0 bg-gradient-to-t from-black via-transparent/30 to-transparent"
      ></div>

      <!-- Text Section -->
    </div>
  </div>

  <div class="w-full p-2">
    <span class="text-md font-bold">{{ event.name }}</span>

    <div class="flex gap-4 items-center">
      <span class="text-sm text-gray-600"
        >{{ event.date | date: 'mediumDate' }} <span> - {{ event.time }}</span></span
      >

      <!-- <span class="text-sm text-gray-300"> {{ event.minPrice }} {{event.maxPrice}}</span> -->
    </div>
    <span class="text-sm text-gray-600">{{ event.location.description }}</span>
    <!-- <span class="text-lg font-bold"></span> -->
  </div>
</section>
